import React from "react";
import "./module-page-shell.scss";

/**
 * Shared page content container for every merchant module.
 * Visual template: Dashboard page shell (max-width, side padding, column gap).
 * Pair with <ModuleHeader bleed /> so the header spans edge-to-edge.
 */
const ModulePageShell = ({
  children,
  className = "",
  padded = true,
  as: Tag = "div",
  ...props
}) => {
  const rootClass = [
    "module-page-shell",
    padded ? "module-page-shell--padded" : "module-page-shell--flush",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag className={rootClass} {...props}>
      {children}
    </Tag>
  );
};

export default ModulePageShell;
